import { register } from 'register-service-worker'

if (import.meta.env.PROD) {
  register(`${import.meta.env.BASE_URL}service-worker.js`, {
    updated(registration) {
      document.dispatchEvent(
        new CustomEvent('swUpdated', { detail: registration })
      )
    },
    error(error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
